import { useState, useEffect } from 'react'
import './Hero.css'

interface HeroProps {
  title: string
  subtitle?: string
  backgroundImage?: string
  height?: string
  isSliding?: boolean
  showCTA?: boolean
  ctaText?: string
  ctaLink?: string
}

const Hero = ({ title, subtitle, backgroundImage, height = "60vh", isSliding = false, showCTA = false, ctaText = "Contact Us", ctaLink = "/contact" }: HeroProps) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  
  // Define the hero images for sliding with their orientations and scaling
  const heroImages = [
    { src: '/hero/hero4.jpg', isPortrait: false, scale: 1.4 },
    { src: '/hero/hero2.jpg', isPortrait: true, scale: 1 }, 
    { src: '/hero/hero3.jpg', isPortrait: false, scale: 1.1 }
  ]

  // Auto-slide functionality
  useEffect(() => {
    if (!isSliding) return

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length)
    }, 4000) // 4 seconds

    return () => clearInterval(interval)
  }, [isSliding, heroImages.length])

  return (
    <section className="hero" style={{ height }}>
      {/* Background Images */}
      {isSliding ? (
        <>
          {heroImages.map((image, index) => (
            <img
              key={index}
              src={image.src}
              alt={`Hero slide ${index + 1}`}
              className={`hero-bg-image ${image.isPortrait ? 'portrait' : 'landscape'} ${index === currentSlide ? 'active' : ''}`}
              style={{ transform: `scale(${image.scale})` }}
            />
          ))}
        </>
      ) : backgroundImage ? (
        <img
          src={backgroundImage}
          alt="Hero background"
          className="hero-bg-image landscape active"
        />
      ) : null}
      
      <div className="hero-content">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
        {showCTA && (
          <a href={ctaLink} className="hero-cta-button">
            {ctaText}
          </a>
        )}
      </div>
      
      {/* Slide indicators */}
      {isSliding && (
        <div className="slide-indicators">
          {heroImages.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </section>
  )
}

export default Hero
